import type { ReactNode } from 'react';

import useIsLocked from '@/ui/hooks/use-is-locked';
import LoginPage from '@/ui/pages/login';

type ProtectedRouteProps = {
  children: ReactNode;
};

function ProtectedRoute({ children }: ProtectedRouteProps): ReactNode {
  const isLocked = useIsLocked();

  if (isLocked) {
    return __STANDALONE_MODE__ ? <LoginPage /> : null;
  }

  return children;
}

export default ProtectedRoute;
